import { render } from "./CatalogSection.vue?vue&type=template&id=f543d042&scoped=true"
import script from "./CatalogSection.vue?vue&type=script&lang=js"
export * from "./CatalogSection.vue?vue&type=script&lang=js"

import "./CatalogSection.vue?vue&type=style&index=0&id=f543d042&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f543d042"]])

export default __exports__